import { MedalCardFragmentFragment } from '@/__generated__/graphql.ts';
import { tournamentMedalsContainer } from '@/routes/_app.p.tournaments_.$id/tournament-medal/tournament-medal.css.ts';
import { TournamentMedal } from '@/routes/_app.p.tournaments_.$id/tournament-medal/tournament-medal.tsx';

type TournamentMedalProps = {
  medals: MedalCardFragmentFragment[];
};
export const TournamentMedals: React.FC<TournamentMedalProps> = ({
  medals,
}) => {
  return (
    <div className={tournamentMedalsContainer}>
      {medals.map((medal) => (
        <TournamentMedal key={medal.id} medal={medal} />
      ))}
    </div>
  );
};
